export default "__VITE_PUBLIC_ASSET__9d744c18__"